import { defineMessages, useIntl } from 'react-intl';

import { Button } from '~/eds/src/components/Button/Button';
import { ContentContainer } from '~/eds/src/components/ContentContainer/ContentContainer';
import { Text } from '~/eds/src/components/Text/Text';
import { PageLayout } from '~/eds/src/modules/PageLayout/PageLayout';
import { api } from '~/redux/api/createApi';
import { useRouting } from '~/routing/useRouting';

const messages = defineMessages({
  publish: {
    id: 'workflowCLMEvolutionWorkflowDetail.publish',
    defaultMessage: 'Publish',
    description: 'Button text to publish a workflow',
  },
  unpublish: {
    id: 'workflowCLMEvolutionWorkflowDetail.unpublish',
    defaultMessage: 'Unpublish',
    description: 'Button text to unpublish a workflow',
  },
});

const WorkflowCLMEvolutionWorkflowDetailPage = () => {
  const intl = useIntl();
  const { params } = useRouting();
  const { workflowId = '' } = params;
  const { data, isLoading } = api.endpoints.getWorkflowK2.useQuery({
    workflowId,
  });
  const [publishWorkflow, { isLoading: isPublishing }] =
    api.endpoints.publishWorkflowK2.useMutation();
  const [unpublishWorkflow, { isLoading: isUnpublishing }] =
    api.endpoints.unpublishWorkflowK2.useMutation();

  const isPublished = data?.published ?? false;
  const isMutating = isPublishing || isUnpublishing;

  const handlePublish = () => {
    if (!data) return;
    publishWorkflow({ workflowId, version: data.version });
  };

  const handleUnpublish = () => {
    unpublishWorkflow({ workflowId });
  };

  return (
    <PageLayout
      title={data?.workflow_definition?.name ?? ''}
      headerCalloutContent={
        data && (
          <Button
            text={intl.formatMessage(
              isPublished ? messages.unpublish : messages.publish,
            )}
            variant={isPublished ? 'tertiary' : 'primary'}
            isLoading={isMutating}
            onClick={isPublished ? handleUnpublish : handlePublish}
          />
        )
      }
    >
      <ContentContainer loadingContent={{ isLoading }}>
        {data && (
          <>
            <Text>{workflowId}</Text>
            <pre>{JSON.stringify(data, null, 2)}</pre>
          </>
        )}
      </ContentContainer>
    </PageLayout>
  );
};

export default WorkflowCLMEvolutionWorkflowDetailPage;
